<template>
  <div class="flex h-full flex-col">
    <div class="grow overflow-y-auto">
      <RouterView />
    </div>

    <BaseRouteTabs :routes="routes" class="shrink-0" />
  </div>
</template>

<script setup lang="ts">
import {
  IconTill,
  IconReceiptFilled as IconHistory,
  IconReports,
  IconMore,
} from "@/icons"
import type { RouteTabDefinition } from "@/components/BaseRouteTabs.vue"

const { isLoggedIn } = useAuth()
const router = useRouter()

const routes = computed<Array<RouteTabDefinition>>(() => [
  {
    to: {
      name: "home",
    },
    label: "Till",
    icon: IconTill,
  },
  {
    to: {
      name: "orderIndex",
    },
    label: "Transactions",
    icon: IconHistory,
  },
  {
    to: {
      name: "reportsIndex",
    },
    label: "Reports",
    icon: IconReports,
  },
  {
    to: {
      name: "moreMenu",
    },
    label: "More",
    icon: IconMore,
  },
])

if (!isLoggedIn.value) {
  router.push({ name: "logInIndex" })
}
</script>
